module.exports = __webpack_public_path__ + "img/intro_sub_uk.67de3653.svg";